import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import FileInput from './FileInput';
import './FileInputStyles.scss';

export default function UploadZone(props) {
  const {
    inputProps,
    setClear = () => {},
    zoneText = '',
    className = '',
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const zoneTextBlock = zoneText || formatMessage({ id: 'file.drop' });
  const { onChange = () => {} } = inputProps;
  const [isDragEnter, setDragEnter] = useState(false);
  const dragEnter = evt => {
    setDragEnter(true);
    evt.preventDefault();
    return false;
  };

  const dragLeave = evt => {
    if (evt.currentTarget.contains(evt.relatedTarget)) return;
    setDragEnter(false);
    evt.preventDefault();
    return false;
  };

  const dragOver = evt => {
    evt.preventDefault();
    return false;
  };

  const drop = evt => {
    const file = evt.dataTransfer?.files[0];
    const data = new FormData();
    data.append('file', file);
    onChange(data);
    setDragEnter(false);
    evt.preventDefault();
    return false;
  };

  return (
    <div className={classNames('upload-zone-wrapper', className)}>
      <div
        className={classNames('upload-zone', { active: isDragEnter })}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDragOver={dragOver}
        onDrop={drop}
      >
        <div className="upload-zone-icon"><Icons
          width={24}
          height={24}
          customIcon
          icon="download"
          className="button-icons"
        />
        </div>
        <div className="upload-zone-text mt-3">{zoneTextBlock}
        </div>
        <div className="upload-zone-button mt-3">
          <FileInput
            variant="button"
            className="avatar-load"
            label={formatMessage({ id: 'select.file' })}
            inputProps={inputProps}
            setClear={setClear}
            notSaveState
          />
        </div>
      </div>
    </div>
  );
}
